import { createContext } from 'react';
import { ID, Response } from '../../../../../_dashboard/helpers';

export interface NewsletterSubscriber {
  _id?: ID;
  email: string;
  isSubscribed: boolean;
  createdAt?: string;
  updatedAt?: string;
}

export type NewsletterQueryResponse = Response<Array<NewsletterSubscriber>>;
export type QueryResponseNewsletterContextProps<T> = {
  dataResponse?: Response<Array<T>> | undefined;
  refetchData: () => void;
  isLoading: boolean;
  query: any;
};

export function createNewsletterResponseContext<T>(initialState: QueryResponseNewsletterContextProps<T>) {
  return createContext(initialState);
}

export const initialNewsletterQueryResponse = { refetchData: () => {}, isLoading: false, query: '' };
